import { render } from "./ConfigurationValue.vue?vue&type=template&id=5c79200c&scoped=true"
import script from "./ConfigurationValue.vue?vue&type=script&lang=js"
export * from "./ConfigurationValue.vue?vue&type=script&lang=js"

import "./ConfigurationValue.vue?vue&type=style&index=0&id=5c79200c&lang=scss&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c79200c"]])

export default __exports__